export const smediasGetters = {
  smediasFormStatus: (state) => state.smediasFormStatus,
  smediasIsEdit: state => state.smediasIsEdit,
  smediasSelectedForEdit: state => state.smediasSelectedForEdit,
};